import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { checkIfLoggedInNoCatch } from '../../actions/auth';

function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [authConfirmed, setAuthConfirmed] = useState(false);

  useEffect(() => {
    checkIfLoggedInNoCatch()
      .then(() => setAuthConfirmed(true))
      .catch(() => {
        navigate('/');
        dispatch({ type: 'CLEAR' });
      });
  }, []);

  return authConfirmed ? children : null;
}

export default ProtectedRoute;
